import { render, staticRenderFns } from "./KanbanSort.vue?vue&type=template&id=95a4696c&"
import script from "./KanbanSort.vue?vue&type=script&lang=js&"
export * from "./KanbanSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports